import axios from '@axios'

const PREFIX = '/email-configuracao'

export default {

  get() {
    return axios.get(`${PREFIX}`)
  },

  update(config) {
    return axios.post(`${PREFIX}`, config)
  },

  validaSMTP(dados) {
    return axios.post(`${PREFIX}/valida-smtp`, dados)
  },

  // Grupos de SMTP
  getGrupos() {
    return axios.get(`${PREFIX}/grupos`)
  },

  salvarGrupo(file, body) {
    const formData = new FormData()
    if (file) formData.append('file', file)
    formData.append('body', JSON.stringify(body))
    return axios.post(`${PREFIX}/grupos`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
  },

  removerGrupo(id) {
    return axios.delete(`${PREFIX}/grupos/${id}`)
  },

  // SMTP por usuário (admin na tela de SMTP)
  getUsuariosSmtp() {
    return axios.get(`${PREFIX}/usuarios`)
  },

  salvarUsuarioSmtp(file, body) {
    const formData = new FormData()
    if (file) formData.append('file', file)
    formData.append('body', JSON.stringify(body))
    return axios.post(`${PREFIX}/usuarios`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
  },

  removerUsuarioSmtp(id) {
    return axios.delete(`${PREFIX}/usuarios/${id}`)
  },

  getUsuariosDisponiveisParaGrupo(ignorarGrupoId) {
    const params = ignorarGrupoId ? { ignorarGrupoId } : {}
    return axios.get(`${PREFIX}/usuarios-disponiveis/grupo`, { params })
  },

  getUsuariosDisponiveisParaIndividual(ignorarSmtpId) {
    const params = ignorarSmtpId ? { ignorarSmtpId } : {}
    return axios.get(`${PREFIX}/usuarios-disponiveis/individual`, { params })
  },
}
